import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import useTitle from "hooks/useTitle";
import { StyledClientFilterItem } from "views/Tasks/styles";
import TanReports from "./tan-reports";
import TraceReports from "./trace-reports";
import AccessDenied from "views/atom-pro/Access/accessDenide";
import { usePermissions } from "context/PermissionsProvider";
import { Permissions } from "data/permissons";

const TanIncomeTaxReports = () => {
  useTitle("ATOM Pro | Sync Status");
  const { permissions } = usePermissions();
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "tanSyncStatus";
  const [active, setActive] = useState(defaultTab);

  useEffect(() => {
    setActive(defaultTab);
  }, [defaultTab]);

  const handleTabChange = (tab: string) => {
    setActive(tab);
    setSearchParams({ tab });
  };
  // if (
  //   !(
  //     permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
  //     permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)
  //   )
  // ) {
  //   return <AccessDenied />;
  // }

  return (
    <Box pl={0} pr={1} mt={0} pt={0}>
      <Box
        pl={2}
        pr={2}
        mb={0}
        mt={0}
        pt={1}
        pb={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgcolor="#F5F5F5"
      >
        <Box display="flex" gap="15px" flexWrap="wrap" alignItems="center">
          <StyledClientFilterItem
            variant="body1"
            color="rgba(0,0,0,0.7)"
            active={active === "tanSyncStatus" ? 1 : 0}
            onClick={() => handleTabChange("tanSyncStatus")}
          >
            TAN Sync Status
          </StyledClientFilterItem>
          <StyledClientFilterItem
            variant="body1"
            color="rgba(0,0,0,0.7)"
            active={active === "tracesSyncStatus" ? 1 : 0}
            onClick={() => handleTabChange("tracesSyncStatus")}
          >
            Traces Sync Status
          </StyledClientFilterItem>
        </Box>
        <Box display="flex" justifyContent="flex-end">
          {/* <Button
                variant="outlined"
                color="secondary"
                onClick={handleExport}
                startIcon={<FileDownloadOutlinedIcon />}
            >
                Export
            </Button> */}
        </Box>
      </Box>
      {active === "tanSyncStatus" && <TanReports tab="tanSyncStatus" />}
      {active === "tracesSyncStatus" && <TraceReports tab="tracesSyncStatus" />}
    </Box>
  );
};

export default TanIncomeTaxReports;
